import { gql } from '@apollo/client'

export const GET_STORE_CHAIN = gql`
  query GetStoreChain($storeChainId: ID!) {
    storeChain(storeChainId: $storeChainId) {
      id
      name
    }
  }
`
